import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import i18n from 'Pods/Shared/I18n'

import axios from 'axios'

function UserSidebarAction({ action, openModal, id }) {
  function redirectToPath(e) {
    if (!App.config.userSignedIn) {
      e.preventDefault()

      App.events.publish('app:login:open', { redirectURL: action.path })

      return
    }

    window.location.href = action.path
  }

  function setFraudStatus(e) {
    e.preventDefault()

    if (!window.confirm(`Are you sure you want to ${action.title} the user?`)) {
      return
    }

    axios.put(action.path)
      .then(() => {
        App.events.publish('app:notification:flash:success', 'User successfully updated.')
        window.location.reload()
      })
      .catch((error) => {
        App.events.publish('app:notification:flash:error', error.response.data.errors.join(', '))
      })
  }

  function setFollowStatus(e, action) {
    e.preventDefault();

    if (!App.config.userSignedIn) {
      App.events.publish('app:login:open', { redirectURL: action.path })
      return
    }

    if (action.path.includes('unfollow') || action.path.includes('unmute')) {
      axios.delete(action.path)
        .then(() => { window.location.reload() })
        .catch((error) => {
          App.events.publish('app:notification:flash:error', error.response.data.errors.join(', '))
        })

      return
    }

    axios.post(action.path)
      .then(() => { window.location.reload() })
      .catch((error) => {
        App.events.publish('app:notification:flash:error', error.response.data.errors.join(', '))
      })
  }

  if (action.type === 'url') {
    if (action.title === 'Hire me' && !action.active) {
      return (
        <Tooltip
          tooltipClassName="u-block u-text-center"
          id={`hire-me-tooltip--${id}`}
          content={i18n.t('no_3d_projects_accepted', { ns: 'global' })}
          wrapperClassName="hire-me-tooltip"
        >
          <button
            className={`btn ${action.style === 'primary' ? 'btn-primary' : 'btn-outline-default btn-white btn-dark'} disabled`}
            disabled
          >
            {action.icon && <Icon type={['far', action.icon]} />}
            {action.title}
          </button>
        </Tooltip>
      )
    }
    return (
      <button
        className={`btn ${action.style === 'primary' ? 'btn-primary' : 'btn-outline-default btn-white btn-dark'} ${!action.active ? 'disabled' : ''}`}
        disabled={!action.active}
        onClick={(e) => redirectToPath(e)}
      >
        {action.icon && <Icon type={['far', action.icon]} />}
        {action.title}
      </button>
    )
  }

  if (action.type === 'fraud') {
    return (
      <button
        className="btn btn-primary"
        disabled={!action.active}
        onClick={(e) => setFraudStatus(e)}
      >
        {action.title}
      </button>
    )
  }

  if (action.type === 'follow' || action.type === 'mute') {
    return (
      <Tooltip
        tooltipClassName="u-block u-text-center"
        content={action.tooltip}
        id={`tooltip--${action.type}`}
        wrapperClassName="hire-me-tooltip"
      >
        <button
          className="btn btn-primary btn-follow"
          disabled={!action.active}
          onClick={(e) => setFollowStatus(e, action)}
        >
          {action.icon && <Icon type={['far', action.icon]} />}
          {action.title}
        </button>
      </Tooltip>
    )
  }

  return (
    <button
      className={`btn ${action.style === 'primary' ? 'btn-primary' : 'btn-outline-default btn-white btn-dark'}`}
      disabled={!action.active}
      onClick={openModal}
    >
      {action.icon
        && <Icon type={['far', action.icon]} />
      }
      {action.title}
    </button>
  )
}

UserSidebarAction.propTypes = {
  openModal: PropTypes.func.isRequired,
  action: PropTypes.shape({
    style: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    path: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
}

export default UserSidebarAction
